import { CLEAR_SITE_DATA } from '../application';
import { RECEIVED_MODELS, RESET_MODELS, ADD_UPLOADING_ID, REMOVE_UPLOADING_ID } from './actions';

const initialState = {
  hashmap: {},
  siteLoaded: undefined,
  uploadingIds: [],
};

// eslint-disable-next-line default-param-last
export function reducer(state = initialState, action) {
  switch (action.type) {
    case RECEIVED_MODELS: {
      const { models, siteId } = action;
      const updatedHashmap = {};
      models.forEach((model) => {
        updatedHashmap[model.id] = model;
      });

      return {
        ...state,
        hashmap: updatedHashmap,
        siteLoaded: siteId,
      };
    }
    case ADD_UPLOADING_ID: {
      return {
        ...state,
        uploadingIds: [...state.uploadingIds, action.modelId],
      };
    }
    case REMOVE_UPLOADING_ID: {
      return {
        ...state,
        uploadingIds: state.uploadingIds.filter((id) => id !== action.modelId),
      };
    }
    case RESET_MODELS:
    case CLEAR_SITE_DATA: {
      // ***IMPORTANT***
      // Explicitly resetting each piece of state here because we've experienced
      // issues with stale state (in visualizations, specifically) - even when returning
      // initialState, using a spread copy of initialState as default state,
      // and/or returning a spread copy of initialState.
      return {
        ...state,
        hashmap: {},
        siteLoaded: undefined,
      };
    }
    default: {
      return state;
    }
  }
}

export default reducer;
